function generateActions() {
    return {
        setOrderError({ commit }, payload) {
            commit('SET_ERROR', payload)
        },
        setOrder({ commit, state }, order) {
            commit('SET_ORDER', order)
            commit('SET_DELIVERY_JOB', {
                trackOrder: state.trackOrder,
                order: order,
            })
            commit('SET_DELIVERY_STATUS', state.deliveryJob)
        },
        setRestaurant({ commit }, restaurant) {
            commit('SET_RESTAURANT', restaurant)
        },
        setTracking({ commit, state }, trackOrder) {
            commit('SET_TRACK_ORDER', trackOrder)
            commit('SET_DELIVERY_JOB', {
                trackOrder: trackOrder,
                order: state.order,
            })
            commit('SET_DELIVERY_STATUS', state.deliveryJob)
        },
        setUpdateStatus({ commit }, payload) {
            commit('SET_UPDATE_STATUS', payload)
        },
        tick({ commit }, now) {
            commit('TICK', now)
        },
        resetDeliveryStatus({ commit }) {
            commit('RESET_DELIVERY_STATUS')
        },
    }
}

export default generateActions
